import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";

import {
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  Snackbar,
  Avatar,
} from "@material-ui/core";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import ConfirmationDialog from "./ConfirmationDialog";
import FullScreenLoader from "./FullScreenLoader";

class DataList extends Component {
  state = {
    isDialogOpen: false,
    dialogAction: null,
    ctxMenuAnchorEl: null,
    activeCxtMenu: null,
  };

  openDialog = (item) =>
    this.setState({
      isDialogOpen: true,
      dialogAction: item.action,
      activeCxtMenu: null,
    });

  closeDialog = () =>
    this.setState({ isDialogOpen: false, dialogAction: null });

  onDialogConfirm = () => {
    this.state.dialogAction();

    this.setState({
      isDialogOpen: false,
      dialogAction: null,
    });
  };

  openCtxMenu = (e, i) => {
    this.setState({ ctxMenuAnchorEl: e.currentTarget, activeCxtMenu: i });
  };

  closeCtxMenu = () => {
    this.setState({ ctxMenuAnchorEl: null, activeCxtMenu: null });
  };

  render() {
    return (
      <Fragment>
        <List>
          {this.props.data.length > 0 ? (
            this.props.data.map((data, i) => {
              return (
                <ListItem
                  key={i}
                  button={!!data.onClick}
                  onClick={data.onClick}
                >
                  <Avatar
                    src={
                      data.avatar && data.avatar.includes("data:image")
                        ? data.avatar
                        : null
                    }
                  >
                    {data.title.substring(0, 1).toUpperCase()}
                  </Avatar>

                  <ListItemText
                    primary={data.title}
                    secondary={data.subtitle}
                  />

                  <ListItemSecondaryAction>
                    {Array.isArray(data.secondaryActions) &&
                      data.secondaryActions.map(
                        ({ icon: Icon, ...action }, i) => {
                          return (
                            <IconButton
                              key={i}
                              edge="end"
                              onClick={action.onClick}
                            >
                              <Icon />
                            </IconButton>
                          );
                        },
                      )}

                    {Array.isArray(data.ctxMenu) &&
                      data.ctxMenu.some((i) => !i.hide) && (
                        <Fragment>
                          <IconButton
                            aria-label="more"
                            aria-controls="long-menu"
                            aria-haspopup="true"
                            onClick={(e) => this.openCtxMenu(e, i)}
                          >
                            <MoreVertIcon />
                          </IconButton>

                          <Menu
                            anchorEl={this.state.ctxMenuAnchorEl}
                            keepMounted
                            open={i === this.state.activeCxtMenu}
                            onClose={this.closeCtxMenu}
                          >
                            {data.ctxMenu.map((menuItem) => {
                              return menuItem.hide ? null : (
                                <MenuItem
                                  key={menuItem.label}
                                  onClick={() => {
                                    if (menuItem.confirm) {
                                      this.openDialog(menuItem);
                                    } else {
                                      menuItem.action();
                                    }
                                  }}
                                >
                                  {menuItem.label}
                                </MenuItem>
                              );
                            })}
                          </Menu>
                        </Fragment>
                      )}
                  </ListItemSecondaryAction>
                </ListItem>
              );
            })
          ) : (
            <ListItem>
              <ListItemText primary="Geen gegevens om te tonen." />
            </ListItem>
          )}
        </List>

        {this.props.isFetching && <FullScreenLoader />}

        <ConfirmationDialog
          title={"Weet u het zeker?"}
          open={this.state.isDialogOpen}
          onConfirmed={this.onDialogConfirm}
          onClose={this.closeDialog}
        />

        <Snackbar
          open={!!this.props.successMessage || !!this.props.errorMessage}
          message={
            this.props.successMessage ||
            (this.props.errorMessage
              ? this.props.errorMessage
              : "Er ging wat fout")
          }
        />
      </Fragment>
    );
  }
}

DataList.propTypes = {
  data: PropTypes.array.isRequired,
  isFetching: PropTypes.bool,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.any,
};

export default DataList;



// WEBPACK FOOTER //
// ./src/components/DataList.js